/** Router errorElement. Must not depend on auth or bootstrap state. */
import { Box, Button, Stack, Typography } from '@mui/material';
import { useRouteError } from 'react-router-dom';
import { useCopy } from '@/hooks/useCopy';

export function RouteError() {
  const error = useRouteError();
  const { t } = useCopy();
  if (import.meta.env.DEV) console.error('Route error:', error);

  return (
    <Box
      role="alert"
      sx={{
        display: 'grid',
        placeItems: 'center',
        minHeight: '60vh',
        textAlign: 'center',
        px: 2,
      }}
    >
      <Stack spacing={2} sx={{ alignItems: 'center' }}>
        <Typography variant="h2" component="h1">
          {t('errors.generic', 'Something went wrong. Please try again.')}
        </Typography>
        <Button variant="outlined" onClick={() => window.location.assign('/')}>
          {t('common.retry', 'Retry')}
        </Button>
      </Stack>
    </Box>
  );
}
